export default __webpack_public_path__ + "static/media/Pradeep.5bfbd29d.jpeg";